import axios from 'axios';

axios.defaults.baseURL = '/api/';
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('id_token')}`;

export default axios;



// WEBPACK FOOTER //
// ./src/helpers/APIRequest.js